export default __webpack_public_path__ + "static/media/exp-img2.3a06329b.svg";